/* Feelora Color &bull; Ultra-Premium Theme Engine */
const FeeloraTheme = (function() {
  const TIER_1_SHIPPING = 499;
  const TIER_2_WIPES = 599;
  const TIER_3_POLISH = 799;

  let cart = [];

  function init() {
    initAnnouncementCarousel();
    loadCart();
    renderCart();
  }

  function initAnnouncementCarousel() {
    const slides = document.querySelectorAll('.announcement-slide');
    if (!slides || slides.length === 0) return;
    let curr = 0;
    setInterval(() => {
      slides[curr].classList.remove('active');
      curr = (curr + 1) % slides.length;
      slides[curr].classList.add('active');
    }, 3600);
  }

  function loadCart() {
    try {
      const saved = localStorage.getItem('feelora_mars_cart');
      if (saved) cart = JSON.parse(saved);
    } catch(e) { cart = []; }
  }

  function saveCart() {
    try {
      localStorage.setItem('feelora_mars_cart', JSON.stringify(cart));
    } catch(e) {}
  }

  function addToCart(title, price) {
    const existing = cart.find(item => item.title === title);
    if (existing) {
      existing.qty += 1;
    } else {
      cart.push({ title, price, qty: 1 });
    }
    saveCart();
    renderCart();
    openCartDrawer();
  }

  function removeFromCart(idx) {
    cart.splice(idx, 1);
    saveCart();
    renderCart();
  }

  function renderCart() {
    const totalCount = cart.reduce((sum, item) => sum + item.qty, 0);
    const subtotal = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);

    const countEl = document.getElementById('cartCount');
    const drawerCountEl = document.getElementById('drawerCount');
    if (countEl) countEl.textContent = totalCount;
    if (drawerCountEl) drawerCountEl.textContent = totalCount;
    const bottomBadge = document.getElementById("bottomCartBadge");
    if (bottomBadge) bottomBadge.textContent = totalCount;

    const listEl = document.getElementById('cartItemsList');
    const emptyMsgEl = document.getElementById('emptyCartMessage');
    const footerEl = document.getElementById('cartFooter');
    const totalEl = document.getElementById('cartTotal');
    const shipFeeEl = document.getElementById('shippingFeeText');
    const upsellsEl = document.getElementById('cartUpsellsBox');

    if (!listEl) return;

    if (cart.length === 0) {
      if (emptyMsgEl) emptyMsgEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
      if (upsellsEl) upsellsEl.style.display = 'none';
      listEl.innerHTML = '';
      if (emptyMsgEl) listEl.appendChild(emptyMsgEl);
    } else {
      if (emptyMsgEl) emptyMsgEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';
      if (upsellsEl) upsellsEl.style.display = 'block';

      let html = '';
      cart.forEach((item, idx) => {
        html += `
          <div class="cart-item-row">
            <div>
              <div class="cart-item-title">${item.title}</div>
              <div class="cart-item-price">₹${item.price} &times; ${item.qty} = ₹${item.price * item.qty}</div>
            </div>
            <button class="cart-item-remove" onclick="FeeloraTheme.removeFromCart(${idx})" title="Remove">&times;</button>
          </div>
        `;
      });
      listEl.innerHTML = html;
    }

    if (totalEl) totalEl.textContent = `₹${subtotal.toFixed(2)}`;

    // Update MARS-Style Multi-Tier Progress
    const step1 = document.getElementById('tierStep1');
    const step2 = document.getElementById('tierStep2');
    const step3 = document.getElementById('tierStep3');
    const barFill = document.getElementById('tierProgress');
    const msgEl = document.getElementById('tierMessage');

    if (barFill && msgEl) {
      let pct = 0;
      if (subtotal >= TIER_3_POLISH) {
        pct = 100;
        step1.classList.add('unlocked');
        step2.classList.add('unlocked');
        step3.classList.add('unlocked');
        msgEl.innerHTML = "🎉 <strong>ALL REWARDS UNLOCKED!</strong> Free Shipping + Free Wipes + Free Nail Polish!";
        if (shipFeeEl) shipFeeEl.innerHTML = "<strong style='color:#1E824C;'>FREE</strong>";
      } else if (subtotal >= TIER_2_WIPES) {
        pct = 70 + Math.round(((subtotal - TIER_2_WIPES) / (TIER_3_POLISH - TIER_2_WIPES)) * 30);
        step1.classList.add('unlocked');
        step2.classList.add('unlocked');
        step3.classList.remove('unlocked');
        const diff = TIER_3_POLISH - subtotal;
        msgEl.innerHTML = `🎁 <strong>Free Wipes Unlocked!</strong> Add <strong>₹${diff.toFixed(2)}</strong> more for FREE Nail Polish!`;
        if (shipFeeEl) shipFeeEl.innerHTML = "<strong style='color:#1E824C;'>FREE</strong>";
      } else if (subtotal >= TIER_1_SHIPPING) {
        pct = 35 + Math.round(((subtotal - TIER_1_SHIPPING) / (TIER_2_WIPES - TIER_1_SHIPPING)) * 35);
        step1.classList.add('unlocked');
        step2.classList.remove('unlocked');
        step3.classList.remove('unlocked');
        const diff = TIER_2_WIPES - subtotal;
        msgEl.innerHTML = `🚚 <strong>Free Delivery Unlocked!</strong> Add <strong>₹${diff.toFixed(2)}</strong> more for FREE Remover Wipes!`;
        if (shipFeeEl) shipFeeEl.innerHTML = "<strong style='color:#1E824C;'>FREE</strong>";
      } else {
        pct = Math.round((subtotal / TIER_1_SHIPPING) * 35);
        step1.classList.remove('unlocked');
        step2.classList.remove('unlocked');
        step3.classList.remove('unlocked');
        const diff = TIER_1_SHIPPING - subtotal;
        msgEl.innerHTML = `Add <strong>₹${diff.toFixed(2)}</strong> more to unlock FREE Delivery across India!`;
        if (shipFeeEl) shipFeeEl.textContent = "₹60 (Free on ₹499+)";
      }
      barFill.style.width = `${pct}%`;
    }
  }

  function openCartDrawer() {
    document.getElementById('cartDrawer')?.classList.add('active');
    document.getElementById('cartOverlay')?.classList.add('active');
  }

  function closeCartDrawer() {
    document.getElementById('cartDrawer')?.classList.remove('active');
    document.getElementById('cartOverlay')?.classList.remove('active');
  }

  function copyCoupon(code, btn) {
    navigator.clipboard?.writeText(code);
    const orig = btn.textContent;
    btn.textContent = "Copied!";
    btn.style.backgroundColor = "var(--color-success)";
    setTimeout(() => {
      btn.textContent = orig;
      btn.style.backgroundColor = "";
    }, 2000);
  }

  function checkPincode() {
    const input = document.getElementById('cartPincodeInput');
    const res = document.getElementById('pincodeResult');
    if (!input || !res) return;
    const val = input.value.trim();
    if (!/^[1-9][0-9]{5}$/.test(val)) {
      res.className = 'pincode-msg pincode-error';
      res.textContent = '❌ Please enter a valid 6-digit Indian Postal Pincode.';
      return;
    }
    res.className = 'pincode-msg pincode-success';
    res.innerHTML = `✅ Pincode <strong>${val}</strong> is Serviceable! Express 2–4 days delivery with Cash on Delivery (COD).`;
  }

  function filterProducts(cat, btn) {
    document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');

    document.querySelectorAll('#productGrid .mars-card').forEach(card => {
      if (cat === 'all' || card.getAttribute('data-cat') === cat) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  function openShadePicker(productTitle) {
    const shade = prompt(`Select shade for ${productTitle}:\n1. Tuscan Red (#033)\n2. Rose Gold (#027)\n3. Super Silver (#SS-02)\n4. Golden Jari (#GJ-01)\n5. Pink Lace (#028)\n\nEnter shade name or number:`, "Tuscan Red");
    if (shade) {
      addToCart(`${productTitle} (${shade})`, 249);
    }
  }

  function switchFinish(type) {
    alert(`Switched finish filter to: ${type.toUpperCase()}! Showing corresponding shades.`);
  }

  function downloadPriceList() {
    alert("Downloading Feelora Wholesale Retailer Price List (PDF)... For immediate distributor onboarding, our Jodhpur sales desk (+91 78488 44444) has been alerted.");
  }

  function proceedToCheckout() {
    window.location.href = "/checkout";
  }

  function toggleMobileNav() {
    alert("Feelora Navigation Menu:\n- Nail Colors\n- 24H Kajal\n- Removers\n- Combos\n- Wholesale");
  }

  function searchProducts(q) {
    if (q) alert(`Searching for '${q}' across Feelora Beauty Collection...`);
  }

  document.addEventListener('DOMContentLoaded', () => { init(); initPhotoSlider(); loadWishlist(); initCookies(); loadCustomerState(); const savedLang = localStorage.getItem('feelora_lang') || 'en'; applyLanguage(savedLang); });

  
  // Plix-Style BYOB Box Engine
  let byobItems = [];

  function toggleByobItem(title, price, el) {
    const idx = byobItems.findIndex(it => it.title === title);
    if (idx > -1) {
      // Remove
      byobItems.splice(idx, 1);
      el.classList.remove('selected');
      el.querySelector('.btn-slot-select').textContent = '+ Choose';
    } else {
      if (byobItems.length >= 3) {
        alert("Your Feelora Box is full (3/3 items). Remove an item or click Add Box to Bag!");
        return;
      }
      byobItems.push({ title, price });
      el.classList.add('selected');
      el.querySelector('.btn-slot-select').textContent = '✓ Added';
    }
    renderByobTray();
  }

  function renderByobTray() {
    for (let i = 1; i <= 3; i++) {
      const slotEl = document.getElementById(`byobSlot${i}`);
      const prevEl = document.getElementById(`slotPreview${i}`);
      const titleEl = document.getElementById(`slotTitle${i}`);
      if (byobItems[i - 1]) {
        if (slotEl) slotEl.classList.add('filled');
        if (prevEl) prevEl.innerHTML = "🎁";
        if (titleEl) titleEl.textContent = byobItems[i - 1].title;
      } else {
        if (slotEl) slotEl.classList.remove('filled');
        if (prevEl) prevEl.textContent = "Empty";
        if (titleEl) titleEl.textContent = `Select Product ${i}`;
      }
    }

    const btn = document.getElementById('btnByobAdd');
    if (btn) {
      if (byobItems.length === 3) {
        btn.disabled = false;
        btn.innerHTML = "Add Custom Box to Bag &bull; ₹499 (3/3) 🎉";
      } else {
        btn.disabled = true;
        btn.innerHTML = `Select 3 Items to Unlock (${byobItems.length}/3)`;
      }
    }
  }

  function addByobToCart() {
    if (byobItems.length !== 3) return;
    const names = byobItems.map(i => i.title).join(" + ");
    addToCart(`Custom Feelora Box: [${names}]`, 499);
    // Reset BYOB
    byobItems = [];
    document.querySelectorAll('.byob-item-card').forEach(c => {
      c.classList.remove('selected');
      c.querySelector('.btn-slot-select').textContent = '+ Choose';
    });
    renderByobTray();
  }

  
  // Rich Product Details Modal State
  let currentModalProduct = {
    title: 'Feelora Bridal & Festive Nail Polish',
    price: 249,
    mrp: 410,
    category: 'nails',
    selectedShade: 'Tuscan Red (#033)',
    finish: 'Festive Gloss',
    qty: 1
  };

  function openProductModal(title, price, mrp, category, defaultShade) {
    currentModalProduct.title = title;
    currentModalProduct.price = price;
    currentModalProduct.mrp = mrp || Math.round(price * 1.5);
    currentModalProduct.category = category || 'nails';
    currentModalProduct.selectedShade = defaultShade || 'Tuscan Red (#033)';
    currentModalProduct.qty = 1;

    // Update Modal DOM
    const titleEl = document.getElementById('modalProductTitle');
    const saleEl = document.getElementById('modalSalePrice');
    const mrpEl = document.getElementById('modalMrpPrice');
    const saveEl = document.getElementById('modalSavePill');
    const btnTotalEl = document.getElementById('modalBtnTotal');
    const shadeNameEl = document.getElementById('modalSelectedShadeName');
    const shadeSecEl = document.getElementById('modalShadeSection');
    const bottleMock = document.getElementById('modalBottleMockup');
    const bottleBody = document.getElementById('modalBottleBody');
    const bottleCap = document.getElementById('modalBottleCap');
    const qtyInput = document.getElementById('modalQtyInput');

    if (titleEl) titleEl.textContent = title;
    if (saleEl) saleEl.textContent = `₹${price}.00`;
    if (mrpEl) mrpEl.textContent = `₹${currentModalProduct.mrp}.00`;
    const offPct = Math.round(((currentModalProduct.mrp - price) / currentModalProduct.mrp) * 100);
    if (saveEl) saveEl.textContent = `Save ${offPct}%`;
    if (btnTotalEl) btnTotalEl.textContent = `₹${price}`;
    if (qtyInput) qtyInput.value = 1;

    if (category === 'eyes') {
      if (shadeSecEl) shadeSecEl.style.display = 'none';
      if (bottleMock) {
        bottleMock.innerHTML = `
          <div style="width: 14px; height: 160px; background: linear-gradient(to right, #111, #333, #111); border-radius: 3px; box-shadow: 0 8px 20px rgba(0,0,0,0.3);"></div>
          <span style="font-size: 11px; font-weight: 700; color: var(--color-primary); background: #FFF; padding: 2px 8px; border-radius: 4px; margin-top: 8px;">24H Intense Jet Black</span>
        `;
      }
    } else if (category === 'removers') {
      if (shadeSecEl) shadeSecEl.style.display = 'none';
      if (bottleMock) {
        bottleMock.innerHTML = `
          <div style="width: 120px; height: 100px; background: #FFF; border: 2px solid #EED4D8; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-weight: 800; color: var(--color-primary); font-size: 12px; box-shadow: 0 8px 20px rgba(0,0,0,0.08);">
            FEELORA CARE<br>ALOE WIPES
          </div>
        `;
      }
    } else {
      if (shadeSecEl) shadeSecEl.style.display = 'block';
      if (bottleMock) {
        bottleMock.innerHTML = `
          <div class="modal-bottle-cap" id="modalBottleCap"></div>
          <div class="modal-bottle-body" id="modalBottleBody" style="background: linear-gradient(160deg, #8E0E28, #D81B60);">
            <span class="modal-bottle-emboss" id="modalBottleLabel">FEELORA<br><small>Festive &amp; Bridal</small></span>
          </div>
        `;
      }
      if (shadeNameEl) shadeNameEl.textContent = currentModalProduct.selectedShade;
    }

    document.getElementById('productModalOverlay')?.classList.add('active');
    document.getElementById('productModalWindow')?.classList.add('active');
  }

  function openProductModalFromCard(cardEl) {
    const parent = cardEl.closest('.mars-card') || cardEl.closest('.product-card');
    if (!parent) return;
    const title = parent.querySelector('.card-product-title, .product-title')?.textContent || 'Feelora Cosmetic';
    const saleText = parent.querySelector('.sale-val, .price-sale')?.textContent || '₹249';
    const price = parseInt(saleText.replace(/[^0-9]/g, '')) || 249;
    const mrpText = parent.querySelector('.mrp-val, .price-mrp')?.textContent || '₹410';
    const mrp = parseInt(mrpText.replace(/[^0-9]/g, '')) || Math.round(price * 1.5);
    const cat = parent.getAttribute('data-cat') || parent.getAttribute('data-category') || 'nails';
    openProductModal(title, price, mrp, cat);
  }

  function closeProductModal() {
    document.getElementById('productModalOverlay')?.classList.remove('active');
    document.getElementById('productModalWindow')?.classList.remove('active');
  }

  function selectModalShade(shadeName, colorHex, finishTag, btnEl) {
    currentModalProduct.selectedShade = shadeName;
    currentModalProduct.finish = finishTag;

    document.querySelectorAll('.modal-swatch-btn').forEach(b => b.classList.remove('active'));
    if (btnEl) btnEl.classList.add('active');

    const nameEl = document.getElementById('modalSelectedShadeName');
    const finishEl = document.getElementById('modalShadeFinishTag');
    const bodyEl = document.getElementById('modalBottleBody');

    if (nameEl) nameEl.textContent = shadeName;
    if (finishEl) finishEl.textContent = finishTag;
    if (bodyEl) {
      bodyEl.style.background = `linear-gradient(160deg, ${colorHex}, #FFFFFF 200%)`;
      bodyEl.style.boxShadow = `0 10px 28px ${colorHex}44, inset 0 0 15px rgba(255,255,255,0.4)`;
    }
  }

  function adjustModalQty(delta) {
    currentModalProduct.qty = Math.max(1, currentModalProduct.qty + delta);
    const qtyInput = document.getElementById('modalQtyInput');
    const totalSpan = document.getElementById('modalBtnTotal');
    if (qtyInput) qtyInput.value = currentModalProduct.qty;
    if (totalSpan) totalSpan.textContent = `₹${currentModalProduct.price * currentModalProduct.qty}`;
  }

  function addModalProductToCart() {
    const titleWithShade = currentModalProduct.category === 'nails' 
      ? `${currentModalProduct.title} (${currentModalProduct.selectedShade})`
      : currentModalProduct.title;

    for (let i = 0; i < currentModalProduct.qty; i++) {
      addToCart(titleWithShade, currentModalProduct.price);
    }
    closeProductModal();
  }

  function buyNowModal() {
    addModalProductToCart();
    proceedToCheckout();
  }

  function orderOnWhatsAppModal() {
    const itemStr = currentModalProduct.category === 'nails' 
      ? `${currentModalProduct.qty}x ${currentModalProduct.title} [Shade: ${currentModalProduct.selectedShade}]`
      : `${currentModalProduct.qty}x ${currentModalProduct.title}`;
    const total = currentModalProduct.price * currentModalProduct.qty;
    const msg = encodeURIComponent(`Hi Feelora Team, I would like to order: ${itemStr} for Total: ₹${total}. Please share payment / delivery details!`);
    window.open(`https://wa.me/917848844444?text=${msg}`, '_blank');
  }

  function checkModalPincode() {
    const input = document.getElementById('modalPincodeInput');
    const res = document.getElementById('modalPincodeResult');
    if (!input || !res) return;
    const val = input.value.trim();
    if (!/^[1-9][0-9]{5}$/.test(val)) {
      res.className = 'modal-pincode-result pincode-error';
      res.textContent = '❌ Please enter a valid 6-digit Indian Pincode.';
      return;
    }
    res.className = 'modal-pincode-result pincode-success';
    res.innerHTML = `✅ Pincode <strong>${val}</strong>: Delivery in 2–4 Business Days | Cash on Delivery Available.`;
  }

  function toggleAccordion(headEl) {
    const item = headEl.closest('.accordion-item');
    if (item) item.classList.toggle('open');
  }

  function setModalThumbView(type) {
    document.querySelectorAll('.modal-thumb').forEach(t => t.classList.remove('active'));
    event.target.classList.add('active');
  }

  // Distributor Form Logic
  function updateMarginPreview(val) {
    const txt = document.getElementById('marginPreviewText');
    if (!txt) return;
    if (val === '5000') {
      txt.innerHTML = "<strong>Trial Retailer Pack (₹5,000):</strong> Unlocks <strong>40% Profit Margin</strong> + 2 Free Shade Charts.";
    } else if (val === '15000') {
      txt.innerHTML = "<strong>Growth Retailer Pack (₹15,000):</strong> Unlocks <strong>50% Profit Margin</strong> + 1 Free Acrylic Counter Display Stand + 10 Shade Art Charts.";
    } else {
      txt.innerHTML = "<strong>Master Stockist Pack (₹50,000):</strong> Unlocks <strong>60% Highest Profit Margin</strong> + City District Exclusivity + Full Marketing Materials.";
    }
  }

  function handleDistributorSubmit(e) {
    e.preventDefault();
    const name = document.getElementById('distName')?.value.trim();
    const phone = document.getElementById('distPhone')?.value.trim();
    const business = document.getElementById('distBusiness')?.value.trim();
    const bType = document.getElementById('distType')?.value;
    const city = document.getElementById('distCity')?.value.trim();
    const pin = document.getElementById('distPincode')?.value.trim();
    const budget = document.getElementById('distBudget')?.value;

    if (!name || !phone || !business || !city || !pin) {
      alert("Please fill in all mandatory fields.");
      return;
    }

    // Format WhatsApp message
    const waMsg = encodeURIComponent(
      `*New Distributor / Retailer Application*\n` +
      `--------------------------------\n` +
      `• *Name:* ${name}\n` +
      `• *Phone:* +91 ${phone}\n` +
      `• *Business Name:* ${business}\n` +
      `• *Type:* ${bType}\n` +
      `• *Location:* ${city} (PIN: ${pin})\n` +
      `• *Order Budget:* ₹${budget}\n\n` +
      `Please activate my retailer account and send the wholesale catalog!`
    );

    const waLink = `https://wa.me/917848844444?text=${waMsg}`;
    const waBtn = document.getElementById('distWhatsAppBtn');
    if (waBtn) waBtn.href = waLink;

    // Show success view
    document.getElementById('distributorForm').style.display = 'none';
    const successCard = document.getElementById('distSuccessCard');
    if (successCard) {
      successCard.style.display = 'block';
      document.getElementById('distSuccessMessage').innerHTML = 
        `Thank you <strong>${name}</strong> (${business})! Your application for <strong>${bType}</strong> in ${city} has been received. Connect directly with our Jodhpur distribution team below:`;
    }
  }

  
  // Hero Slider Engine
  let heroSlideIdx = 0;
  let heroSliderTimer = null;

  function initHeroSlider() {
    startHeroSliderTimer();
  }

  function startHeroSliderTimer() {
    if (heroSliderTimer) clearInterval(heroSliderTimer);
    heroSliderTimer = setInterval(() => {
      changeHeroSlide(1);
    }, 4500);
  }

  function changeHeroSlide(delta) {
    const slides = document.querySelectorAll('.hero-slide-item');
    if (!slides || slides.length === 0) return;
    slides[heroSlideIdx].classList.remove('active');
    heroSlideIdx = (heroSlideIdx + delta + slides.length) % slides.length;
    slides[heroSlideIdx].classList.add('active');
    updateHeroDots();
    startHeroSliderTimer();
  }

  function setHeroSlide(idx) {
    const slides = document.querySelectorAll('.hero-slide-item');
    if (!slides || slides.length === 0) return;
    slides[heroSlideIdx].classList.remove('active');
    heroSlideIdx = idx;
    slides[heroSlideIdx].classList.add('active');
    updateHeroDots();
    startHeroSliderTimer();
  }

  function updateHeroDots() {
    const dots = document.querySelectorAll('.slider-dot');
    dots.forEach((d, i) => {
      if (i === heroSlideIdx) d.classList.add('active');
      else d.classList.remove('active');
    });
  }

  // Wishlist System
  let wishlist = [];

  function loadWishlist() {
    try {
      const saved = localStorage.getItem('feelora_wishlist');
      if (saved) wishlist = JSON.parse(saved);
    } catch(e) { wishlist = []; }
    renderWishlist();
  }

  function saveWishlist() {
    try {
      localStorage.setItem('feelora_wishlist', JSON.stringify(wishlist));
    } catch(e) {}
  }

  function toggleWishlistItem(title, price, el) {
    const idx = wishlist.findIndex(item => item.title === title);
    if (idx > -1) {
      wishlist.splice(idx, 1);
      if (el) el.classList.remove('active');
    } else {
      wishlist.push({ title, price });
      if (el) el.classList.add('active');
    }
    saveWishlist();
    renderWishlist();
  }

  function renderWishlist() {
    const count = wishlist.length;
    const headerEl = document.getElementById('wishlistHeaderCount');
    const drawerCount = document.getElementById('wishlistCount');
    const listEl = document.getElementById('wishlistItemsList');
    const emptyEl = document.getElementById('emptyWishlistMsg');

    if (headerEl) headerEl.textContent = count;
    if (drawerCount) drawerCount.textContent = count;

    if (!listEl) return;
    if (count === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      listEl.innerHTML = '';
      if (emptyEl) listEl.appendChild(emptyEl);
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      let html = '';
      wishlist.forEach((item, idx) => {
        html += `
          <div class="wishlist-item-card">
            <div class="wishlist-item-left">
              <h5>${item.title}</h5>
              <span>₹${item.price}</span>
            </div>
            <div>
              <button class="btn btn-sm btn-primary" onclick="FeeloraTheme.addToCart('${item.title}', ${item.price})">Move to Bag</button>
              <button class="btn btn-sm btn-outline" onclick="FeeloraTheme.removeFromWishlist(${idx})">&times;</button>
            </div>
          </div>
        `;
      });
      listEl.innerHTML = html;
    }
  }

  function removeFromWishlist(idx) {
    wishlist.splice(idx, 1);
    saveWishlist();
    renderWishlist();
  }

  function openWishlist() {
    document.getElementById('wishlistOverlay')?.classList.add('active');
    document.getElementById('wishlistDrawer')?.classList.add('active');
  }

  function closeWishlist() {
    document.getElementById('wishlistOverlay')?.classList.remove('active');
    document.getElementById('wishlistDrawer')?.classList.remove('active');
  }

  // Cookie Consent System
  function initCookies() {
    const accepted = localStorage.getItem('feelora_cookie_consent');
    if (!accepted) {
      const banner = document.getElementById('cookieBanner');
      if (banner) banner.style.display = 'block';
    } else {
      const banner = document.getElementById('cookieBanner');
      if (banner) banner.style.display = 'none';
    }
  }

  function acceptCookies() {
    localStorage.setItem('feelora_cookie_consent', 'accepted');
    const banner = document.getElementById('cookieBanner');
    if (banner) banner.style.display = 'none';
  }

  function declineCookies() {
    localStorage.setItem('feelora_cookie_consent', 'declined');
    const banner = document.getElementById('cookieBanner');
    if (banner) banner.style.display = 'none';
  }

  // Live Search System
  const CATALOG_PRODUCTS = [
    { title: 'Feelora Bridal & Festive Nail Polish', price: 249, cat: 'nails' },
    { title: 'Feelora Everyday Office Nail Polish', price: 189, cat: 'nails' },
    { title: 'Feelora 24H Intense Black Kajal Stick', price: 199, cat: 'eyes' },
    { title: 'Feelora Gentle Nail Remover Wipes', price: 199, cat: 'removers' },
    { title: 'Feelora Liquid Nail Polish Remover 100ml', price: 199, cat: 'removers' },
    { title: 'Feelora Premium Golden Jari Glitter', price: 199, cat: 'nails' },
    { title: 'Feelora Super Silver Mirror Polish', price: 209, cat: 'nails' },
    { title: 'Feelora Pure Cotton Handkerchiefs (1 Dozen)', price: 295, cat: 'hankies' }
  ];

  function openSearchModal() {
    document.getElementById('searchOverlay')?.classList.add('active');
    document.getElementById('searchModal')?.classList.add('active');
    document.getElementById('liveSearchInput')?.focus();
  }

  function closeSearchModal() {
    document.getElementById('searchOverlay')?.classList.remove('active');
    document.getElementById('searchModal')?.classList.remove('active');
  }

  function handleLiveSearch(query) {
    const listEl = document.getElementById('searchResultsList');
    if (!listEl) return;
    const q = query.trim().toLowerCase();
    if (!q) {
      listEl.innerHTML = '';
      return;
    }
    const filtered = CATALOG_PRODUCTS.filter(p => p.title.toLowerCase().includes(q));
    if (filtered.length === 0) {
      listEl.innerHTML = `<p style="padding:10px 0; color:#888;">No cosmetics found for "${query}". Try searching "Kajal" or "Festive".</p>`;
    } else {
      let html = '';
      filtered.forEach(p => {
        html += `
          <div class="search-item-row" onclick="FeeloraTheme.openProductModal('${p.title}', ${p.price}, ${Math.round(p.price*1.5)}, '${p.cat}')">
            <div>
              <strong>${p.title}</strong>
              <div style="font-size:12px; color:var(--color-primary); font-weight:bold;">₹${p.price}.00</div>
            </div>
            <button class="btn btn-sm btn-outline">View Product</button>
          </div>
        `;
      });
      listEl.innerHTML = html;
    }
  }

  function searchQuery(keyword) {
    const inp = document.getElementById('liveSearchInput');
    if (inp) {
      inp.value = keyword;
      handleLiveSearch(keyword);
    }
  }

  // Customer Account System (Login & Dashboard)
  let currentUser = null;

  function loadCustomerState() {
    try {
      const u = localStorage.getItem('feelora_customer');
      if (u) currentUser = JSON.parse(u);
    } catch(e) {}
  }

  function openAccountModal() {
    document.getElementById('accountOverlay')?.classList.add('active');
    document.getElementById('accountModal')?.classList.add('active');
    renderAccountModal();
  }

  function closeAccountModal() {
    document.getElementById('accountOverlay')?.classList.remove('active');
    document.getElementById('accountModal')?.classList.remove('active');
  }

  function renderAccountModal() {
    const authView = document.getElementById('authView');
    const dashView = document.getElementById('dashboardView');
    if (currentUser) {
      if (authView) authView.style.display = 'none';
      if (dashView) dashView.style.display = 'block';
      const nameEl = document.getElementById('dashUserName');
      const phoneEl = document.getElementById('dashUserPhone');
      if (nameEl) nameEl.textContent = currentUser.name || 'Priya Sharma';
      if (phoneEl) phoneEl.textContent = `+91 ${currentUser.phone || '98765 43210'} • Jodhpur, RJ`;
    } else {
      if (authView) authView.style.display = 'block';
      if (dashView) dashView.style.display = 'none';
    }
  }

  function handleAuthSubmit(e) {
    e.preventDefault();
    const inp = document.getElementById('authInput')?.value.trim();
    currentUser = {
      name: inp.includes('@') ? inp.split('@')[0] : 'Priya Sharma',
      phone: inp.includes('@') ? '9876543210' : inp,
      isLoggedIn: true
    };
    try {
      localStorage.setItem('feelora_customer', JSON.stringify(currentUser));
    } catch(e) {}
    renderAccountModal();
  }

  function logout() {
    currentUser = null;
    localStorage.removeItem('feelora_customer');
    renderAccountModal();
  }

  // Live Tracking Modal
  function openOrderTracking(orderId, courier, awb) {
    alert(
      `📦 LIVE ORDER TRACKING \n` +
      `-------------------------------------\n` +
      `Order: ${orderId}\n` +
      `Courier Partner: ${courier} (Air Express)\n` +
      `AWB Tracking Number: ${awb}\n` +
      `Current Status: Out for Delivery in Jodhpur\n` +
      `Expected Delivery: Today by 6:00 PM\n\n` +
      `Live GPS tracking link dispatched to your WhatsApp mobile number!`
    );
  }

  // GST Bill / Tax Invoice Download Simulation
  function downloadGstBill(orderId, amount) {
    alert(
      `📄 OFFICIAL GST TAX INVOICE\n` +
      `-------------------------------------\n` +
      `Invoice No: INV-2026-${orderId}\n` +
      `Seller: FEELORA COLOR\n` +
      `GSTIN: 08AAKFF9323K1Z0\n` +
      `Address: Plot 298, Shiv Sagar, Near Mahamandir, Jodhpur, RJ - 342304\n` +
      `HSN Code: 3304 (Beauty & Makeup Preparations)\n` +
      `Taxable Amount: ₹${(amount / 1.18).toFixed(2)}\n` +
      `GST (18%): ₹${(amount - (amount / 1.18)).toFixed(2)}\n` +
      `Total Invoice Amount: ₹${amount}.00\n\n` +
      `Generating printable Tax Invoice PDF...`
    );
  }

  // Bilingual Language Engine (English & हिंदी)
  let currentLang = 'en';

  const TRANSLATIONS = {
    en: {
      langLabel: 'हिंदी',
      announcements: [
        '🎉 <strong>FESTIVE SALE LIVE!</strong> Use Code <strong>FEELORA10</strong> for Flat 10% Off!',
        '🚚 <strong>FREE Delivery</strong> Across India on All Orders Over ₹499!',
        '🎁 <strong>FREE GIFT:</strong> Unlocked on Orders Above ₹599 (Free Wipes worth ₹199)'
      ],
      searchPlaceholder: 'Search Kajal, Nail Polish, Removers...',
      categories: {
        catNewArrivals: '✨ New Arrivals',
        catBestsellers: '🔥 Bestsellers',
        catUnder199: '🏷️ Under ₹199 Club',
        catNailColors: '💅 Nail Polish (36+ Shades)',
        catEyes: '👁️ 24H Kajal',
        catRemovers: '🧴 Removers & Wipes',
        catConcerns: '🎯 Shop by Concern',
        catB2b: '💼 Retailer / Wholesale'
      },
      heroSlides: [
        {
          pill: 'FESTIVE & BRIDAL 2026',
          title: 'Luxury Bridal & Festive Shades',
          desc: '1-Stroke mirror finish formulated for Indian celebrations. Up to 7 days chip-free stay at ₹249.',
          btn: 'Shop Bridal Collection →'
        },
        {
          pill: 'EVERYDAY OFFICE ELEGANCE',
          title: 'Subtle Nude Office Polishes',
          desc: 'Sophisticated pink laces and chestnuts designed for everyday professional grace at ₹189.',
          btn: 'Shop Office Nudes →'
        },
        {
          pill: '24H WATERPROOF FORMULA',
          title: 'Deep Black Kajal Stick',
          desc: 'Enriched with Vitamin E & Almond Oil, 24-hour intense jet black at ₹129.',
          btn: 'Shop 24H Kajal →'
        }
      ],
      bubbles: {
        bestsellers: 'Bestsellers',
        byob: 'Build A Box',
        under199: 'Under ₹199',
        concerns: 'By Concern'
      },
      newArrivalsTitle: '✨ New Arrivals & Trending Collection',
      newArrivalsDesc: 'Direct from our Jodhpur formulation labs • 100% Vegan & Cruelty-Free',
      reviewsSub: 'REAL EXPERIENCES',
      reviewsTitle: '⭐️ Customer Reviews & Ratings',
      reviewsDesc: 'Over 2,400+ Indian women trust Feelora Color for daily shine and festive elegance.',
      b2bBadge: 'WHOLESALE & DISTRIBUTOR OPPORTUNITY',
      b2bTitle: '"Feelora Ke Saath Business Bhi Glow Karta Hai"',
      b2bDesc: 'Are you a cosmetics shopkeeper, beauty parlor owner, or regional stockist? Partner with Feelora for attractive wholesale margins (40%–60%) and direct factory supply.',
      b2bBtn: 'Open Dedicated B2B Portal →',
      cookieText: '🍪 <strong>कुकीज और प्राइवेसी (Cookie Policy):</strong> We use cookies to personalize your beauty shopping experience, remember your cart, and track order deliveries across India.',
      cookieBtn: 'Allow Cookies',
      bottomNav: {
        home: 'Home',
        shop: 'Shop',
        search: 'Search',
        cart: 'Cart',
        account: 'Account'
      },
      addBag: 'Add to Bag',
      quickView: 'Quick View',
      buyNow: 'Buy Now (Instant UPI / COD)'
    },
    hi: {
      langLabel: 'English',
      announcements: [
        '🎉 <strong>फेस्टिव सेल लाइव!</strong> कूपन कोड <strong>FEELORA10</strong> पर पाएं 10% की सीधी छूट!',
        '🚚 <strong>पूरे भारत में मुफ्त डिलीवरी</strong> ₹499 से अधिक के सभी ऑर्डरों पर!',
        '🎁 <strong>मुफ्त उपहार:</strong> ₹599 से अधिक के ऑर्डर पर मुफ्त एलोवेरा वाइप्स (मूल्य ₹199)'
      ],
      searchPlaceholder: 'काजल, नेल पॉलिश, रिमूवर खोजें...',
      categories: {
        catNewArrivals: '✨ नए उत्पाद',
        catBestsellers: '🔥 बेस्टसेलर्स',
        catUnder199: '🏷️ ₹199 क्लब',
        catNailColors: '💅 नेल पॉलिश (36+ शेड्स)',
        catEyes: '👁️ 24H वॉटरप्रूफ काजल',
        catRemovers: '🧴 रिमूवर और वाइप्स',
        catConcerns: '🎯 ज़रूरत के अनुसार',
        catB2b: '💼 डिस्ट्रीब्यूटर व होलसेल'
      },
      heroSlides: [
        {
          pill: 'शादी व त्योहार 2026',
          title: 'लक्ज़री ब्राइडल और फेस्टिव शेड्स',
          desc: '1-स्ट्रोक मिरर फिनिश, खास भारतीय त्योहारों और शादियों के लिए। 7 दिनों तक नो-चिपिंग सिर्फ ₹249 में।',
          btn: 'ब्राइडल कलेक्शन देखें →'
        },
        {
          pill: 'रोज़मर्रा के ऑफिस के लिए',
          title: 'सटल न्यूड ऑफिस नेल पॉलिश',
          desc: 'सॉफ़िस्टिकेटेड पिंक और न्यूड चेस्टनट शेड्स, रोज़ाना के ग्रेस के लिए मात्र ₹189 में।',
          btn: 'न्यूड शेड्स देखें →'
        },
        {
          pill: '24H वॉटरप्रूफ फॉर्मूला',
          title: 'डीप ब्लैक काजल स्टिक',
          desc: 'विटामिन ई और बादाम तेल युक्त, 24 घंटे गहरा काला और स्मज-फ्री सिर्फ ₹129 में।',
          btn: '24H काजल अभी खरीदें →'
        }
      ],
      bubbles: {
        bestsellers: 'बेस्टसेलर्स',
        byob: 'कॉम्बो पैक',
        under199: '₹199 में',
        concerns: 'स्किन केयर'
      },
      newArrivalsTitle: '✨ नए उत्पाद और ट्रेंडिंग कलेक्शंस',
      newArrivalsDesc: 'सीधे हमारी जोधपुर फैक्ट्री से निर्मित • 100% वीगन और क्रूएल्टी-फ्री',
      reviewsSub: 'ग्राहकों का भरोसा',
      reviewsTitle: '⭐️ कस्टमर रिव्यू और रेटिंग्स (4.9★)',
      reviewsDesc: 'पूरे भारत की 2,400+ महिलाएं रोज़ाना के ब्यूटी ग्लो के लिए फीलोरा पर भरोसा करती हैं।',
      b2bBadge: 'होलसेल व डिस्ट्रीब्यूटर पार्टनरशिप',
      b2bTitle: '"फीलोरा के साथ बिजनेस भी Glow करता है"',
      b2bDesc: 'क्या आप ब्यूटी पार्लर, कॉस्मेटिक्स दुकानदार या रीजनल होलसेलर हैं? 40% से 60% तक के आकर्षक डीलर मार्जिन और सीधे फैक्ट्री रेट पर फीलोरा से जुड़ें।',
      b2bBtn: 'होलसेल पोर्टल व रेट लिस्ट देखें →',
      cookieText: '🍪 <strong>कुकीज और प्राइवेसी (Cookie Policy):</strong> हम आपकी खरीदारी को आसान बनाने, कार्ट याद रखने और डिलीवरी ट्रैक करने के लिए कुकीज़ का उपयोग करते हैं।',
      cookieBtn: 'कुकीज़ स्वीकार करें',
      bottomNav: {
        home: 'होम',
        shop: 'शॉप',
        search: 'सर्च',
        cart: 'कार्ट',
        account: 'खाता / B2B'
      },
      addBag: 'बैग में जोड़ें',
      quickView: 'विवरण देखें',
      buyNow: 'तुरंत खरीदें (UPI / COD)'
    }
  };

  function applyLanguage(lang) {
    currentLang = lang;
    try { localStorage.setItem('feelora_lang', lang); } catch(e) {}
    const t = TRANSLATIONS[lang] || TRANSLATIONS.en;

    // Toggle button label
    const labelEl = document.getElementById('currentLangLabel');
    if (labelEl) labelEl.textContent = t.langLabel;

    // Search placeholder
    const searchInp = document.getElementById('headerSearchInput');
    if (searchInp) searchInp.placeholder = t.searchPlaceholder;

    // Announcement ticker slides
    const annSlides = document.querySelectorAll('.announcement-slide span');
    annSlides.forEach((span, idx) => {
      if (t.announcements[idx]) span.innerHTML = t.announcements[idx];
    });

    // Category pills
    Object.keys(t.categories).forEach(k => {
      document.querySelectorAll().forEach(el => {
        el.textContent = t.categories[k];
      });
    });

    // Hero Slider Slides
    const heroSlides = document.querySelectorAll('.photo-slide');
    heroSlides.forEach((slide, idx) => {
      const data = t.heroSlides[idx];
      if (data) {
        const pill = slide.querySelector('.photo-pill');
        if (pill) pill.textContent = data.pill;
        const h2 = slide.querySelector('h2');
        if (h2) h2.textContent = data.title;
        const p = slide.querySelector('p');
        if (p) p.textContent = data.desc;
        const btn = slide.querySelector('button.btn');
        if (btn) btn.textContent = data.btn;
      }
    });

    // Story Bubbles
    const bubbles = document.querySelectorAll('.story-bubble-item .bubble-label');
    if (bubbles.length >= 4) {
      bubbles[0].textContent = t.bubbles.bestsellers;
      bubbles[1].textContent = t.bubbles.byob;
      bubbles[2].textContent = t.bubbles.under199;
      bubbles[3].textContent = t.bubbles.concerns;
    }

    // New Arrivals
    const newArrSection = document.getElementById('new-arrivals');
    if (newArrSection) {
      const h2 = newArrSection.querySelector('.section-header h2');
      if (h2) h2.innerHTML = t.newArrivalsTitle;
      const p = newArrSection.querySelector('.section-header p');
      if (p) p.innerHTML = t.newArrivalsDesc;
    }

    // Customer Reviews
    const reviewsSection = document.getElementById('customer-reviews');
    if (reviewsSection) {
      const sub = reviewsSection.querySelector('.sub-heading');
      if (sub) sub.textContent = t.reviewsSub;
      const h2 = reviewsSection.querySelector('.main-heading');
      if (h2) h2.innerHTML = t.reviewsTitle;
      const desc = reviewsSection.querySelector('.section-desc');
      if (desc) desc.textContent = t.reviewsDesc;
    }

    // B2B Teaser
    const b2bSection = document.getElementById('b2b-teaser');
    if (b2bSection) {
      const badge = b2bSection.querySelector('.b2b-teaser-badge');
      if (badge) badge.textContent = t.b2bBadge;
      const h2 = b2bSection.querySelector('.b2b-teaser-title');
      if (h2) h2.textContent = t.b2bTitle;
      const p = b2bSection.querySelector('.b2b-teaser-desc');
      if (p) p.textContent = t.b2bDesc;
      const btn = b2bSection.querySelector('.b2b-teaser-action a');
      if (btn) btn.textContent = t.b2bBtn;
    }

    // Bottom Navigation Bar
    const bHome = document.querySelector('[data-i18n="bottomNavHome"]');
    if (bHome) bHome.textContent = t.bottomNav.home;
    const bShop = document.querySelector('[data-i18n="bottomNavShop"]');
    if (bShop) bShop.textContent = t.bottomNav.shop;
    const bSearch = document.querySelector('[data-i18n="bottomNavSearch"]');
    if (bSearch) bSearch.textContent = t.bottomNav.search;
    const bCart = document.querySelector('[data-i18n="bottomNavCart"]');
    if (bCart) bCart.textContent = t.bottomNav.cart;
    const bAccount = document.querySelector('[data-i18n="bottomNavAccount"]');
    if (bAccount) bAccount.textContent = t.bottomNav.account;

    // Cookie Banner
    const cookieText = document.querySelector('.cookie-consent-banner .cookie-text');
    if (cookieText) cookieText.innerHTML = t.cookieText;
    const cookieBtn = document.querySelector('.cookie-consent-banner .btn-primary');
    if (cookieBtn) cookieBtn.textContent = t.cookieBtn;

    // Product card buttons
    document.querySelectorAll('.btn-add-bag').forEach(b => {
      b.textContent = t.addBag;
    });
    document.querySelectorAll('.btn-quick-view').forEach(b => {
      b.textContent = t.quickView;
    });

    // Modal buttons
    document.querySelectorAll('.modal-add-cart-btn').forEach(b => {
      const priceText = currentModalProduct ? currentModalProduct.price : '149';
      b.innerHTML = t.addBag + ' &bull; <span id="modalBtnTotal">₹' + priceText + '</span>';
    });
    document.querySelectorAll('.btn-buy-now').forEach(b => {
      b.textContent = '⚡ ' + t.buyNow;
    });
  }

  function toggleLanguage() {
    const nextLang = currentLang === 'en' ? 'hi' : 'en';
    applyLanguage(nextLang);
  }

  // Page Navigation Router for Preview & Theme
  function navigateTo(page) {
    const homeView = document.getElementById('homePageView');
    const distView = document.getElementById('distributorPageView');
    const prodView = document.getElementById('productPageView');
    const storeView = document.getElementById('storeCatalogView');

    if (!homeView) {
      if (page === 'store') window.location.href = '/collections/all';
      else if (page === 'distributor') window.location.href = '/pages/distributor';
      else window.location.href = '/';
      return;
    }

    if (homeView) homeView.style.display = 'none';
    if (distView) distView.style.display = 'none';
    if (prodView) prodView.style.display = 'none';
    if (storeView) storeView.style.display = 'none';

    if (page === 'distributor' && distView) {
      distView.style.display = 'block';
    } else if (page === 'store' && storeView) {
      storeView.style.display = 'block';
    } else if (page === 'product' && prodView) {
      prodView.style.display = 'block';
    } else if (homeView) {
      homeView.style.display = 'block';
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function filterStoreCatalog(cat, btn) {
    document.querySelectorAll('.col-filter-pill').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');

    const cards = document.querySelectorAll('#storeCatalogGrid .mars-card');
    cards.forEach(c => {
      const cardCat = c.getAttribute('data-cat') || '';
      const price = parseInt(c.getAttribute('data-price') || '0', 10);
      if (cat === 'all') {
        c.style.display = 'flex';
      } else if (cat === 'under199') {
        c.style.display = price <= 199 ? 'flex' : 'none';
      } else {
        c.style.display = (cardCat === cat) ? 'flex' : 'none';
      }
    });
  }

  function sortStoreCatalog(sortType) {
    const grid = document.getElementById('storeCatalogGrid');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('.mars-card'));

    cards.sort((a, b) => {
      const priceA = parseInt(a.getAttribute('data-price') || '0', 10);
      const priceB = parseInt(b.getAttribute('data-price') || '0', 10);
      const rateA = parseFloat(a.getAttribute('data-rating') || '0');
      const rateB = parseFloat(b.getAttribute('data-rating') || '0');

      if (sortType === 'price-low') return priceA - priceB;
      if (sortType === 'price-high') return priceB - priceA;
      if (sortType === 'rating') return rateB - rateA;
      return 0;
    });

    cards.forEach(c => grid.appendChild(c));
  }

  
  // Mobile Nav Drawer Functions (Real Side Drawer, Zero Alerts)
  function openMobileNav() {
    document.getElementById('mobileNavOverlay')?.classList.add('active');
    document.getElementById('mobileNavDrawer')?.classList.add('active');
  }

  function closeMobileNav() {
    document.getElementById('mobileNavOverlay')?.classList.remove('active');
    document.getElementById('mobileNavDrawer')?.classList.remove('active');
  }

  // Photo Slider Controls
  let currentPhotoSlide = 0;
  let photoSliderTimer = null;

  function initPhotoSlider() {
    startPhotoTimer();
  }

  function startPhotoTimer() {
    if (photoSliderTimer) clearInterval(photoSliderTimer);
    photoSliderTimer = setInterval(() => {
      changePhotoSlide(1);
    }, 4500);
  }

  function changePhotoSlide(delta) {
    const slides = document.querySelectorAll('.photo-slide');
    if (!slides || slides.length === 0) return;
    slides[currentPhotoSlide].classList.remove('active');
    currentPhotoSlide = (currentPhotoSlide + delta + slides.length) % slides.length;
    slides[currentPhotoSlide].classList.add('active');
    updatePhotoDots();
    startPhotoTimer();
  }

  function setPhotoSlide(idx) {
    const slides = document.querySelectorAll('.photo-slide');
    if (!slides || slides.length === 0) return;
    slides[currentPhotoSlide].classList.remove('active');
    currentPhotoSlide = idx;
    slides[currentPhotoSlide].classList.add('active');
    updatePhotoDots();
    startPhotoTimer();
  }

  function updatePhotoDots() {
    const dots = document.querySelectorAll('.p-dot');
    dots.forEach((d, i) => {
      if (i === currentPhotoSlide) d.classList.add('active');
      else d.classList.remove('active');
    });
  }

  // Auth Tabs (Login vs Register)
  function switchAuthTab(tab) {
    const logTab = document.getElementById('tabLoginBtn');
    const regTab = document.getElementById('tabRegisterBtn');
    const logForm = document.getElementById('loginForm');
    const regForm = document.getElementById('registerForm');

    if (tab === 'login') {
      logTab?.classList.add('active');
      regTab?.classList.remove('active');
      if (logForm) logForm.style.display = 'flex';
      if (regForm) regForm.style.display = 'none';
    } else {
      regTab?.classList.add('active');
      logTab?.classList.remove('active');
      if (logForm) logForm.style.display = 'none';
      if (regForm) regForm.style.display = 'flex';
    }
  }

  function sendOtpSimulation() {
    const phone = document.getElementById('regPhone')?.value.trim();
    if (!phone || phone.length < 10) {
      alert("Please enter a valid 10-digit mobile number first.");
      return;
    }
    const otpGroup = document.getElementById('otpGroup');
    if (otpGroup) otpGroup.style.display = 'flex';
    alert(`✓ Verification OTP sent to +91 ${phone} via SMS/WhatsApp! Use demo code: 4829`);
  }

  function handleLogin(e) {
    e.preventDefault();
    const email = document.getElementById('loginEmail')?.value.trim() || 'Priya Sharma';
    currentUser = {
      name: email.includes('@') ? email.split('@')[0] : email,
      phone: '98765 43210',
      isLoggedIn: true
    };
    try { localStorage.setItem('feelora_customer', JSON.stringify(currentUser)); } catch(e){}
    renderAccountModal();
  }

  function handleRegister(e) {
    e.preventDefault();
    const name = document.getElementById('regName')?.value.trim();
    const phone = document.getElementById('regPhone')?.value.trim();
    const otp = document.getElementById('regOtp')?.value.trim();

    if (otp !== '4829' && otp !== '1234' && otp.length !== 4) {
      alert("Invalid OTP code. Please enter 4829 to verify.");
      return;
    }

    currentUser = {
      name: name || 'Priya Sharma',
      phone: phone || '98765 43210',
      isLoggedIn: true
    };
    try { localStorage.setItem('feelora_customer', JSON.stringify(currentUser)); } catch(e){}
    alert(`🎉 Account successfully created for ${name}! Welcome to Feelora Color.`);
    renderAccountModal();
  }

  // Enhanced Multi-Page Router for Preview & Production
  function navigateTo(page, productData) {
    const homeView = document.getElementById('homePageView');
    const distView = document.getElementById('distributorPageView');
    const prodView = document.getElementById('productPageView');

    if (page === 'distributor') {
      if (homeView) homeView.style.display = 'none';
      if (prodView) prodView.style.display = 'none';
      if (distView) distView.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (page === 'product' && productData) {
      openProductModal(productData.title, productData.price, productData.mrp, productData.cat, productData.shade);
    } else {
      if (distView) distView.style.display = 'none';
      if (prodView) prodView.style.display = 'none';
      if (homeView) homeView.style.display = 'block';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }


  // ==========================================
  // DEDICATED PRODUCT POST PAGE LOGIC
  // ==========================================
  let productPostData = {
    title: 'Feelora Bridal & Festive Nail Polish',
    price: 249,
    mrp: 410,
    qty: 1,
    shade: 'Tuscan Red (#033)',
    color: '#8E0E28',
    finish: 'Festive High-Gloss'
  };

  function navigateToProduct(title, price, mrp, cat, color) {
    productPostData.title = title || 'Feelora Bridal & Festive Nail Polish';
    productPostData.price = price || 249;
    productPostData.mrp = mrp || 410;
    productPostData.color = color || '#8E0E28';
    productPostData.qty = 1;

    // Check if in interactive preview router or live page
    const prodPageView = document.getElementById('productPageView');
    const homePageView = document.getElementById('homePageView');
    const distPageView = document.getElementById('distributorPageView');

    if (prodPageView && homePageView) {
      homePageView.style.display = 'none';
      if (distPageView) distPageView.style.display = 'none';
      prodPageView.style.display = 'block';
      updateProductPostDOM();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // In live Shopify environment, follow the native link
      const handle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      window.location.href = '/products/' + handle;
    }
  }

  function updateProductPostDOM() {
    const titleEl = document.getElementById('prodPageTitle');
    const crumbEl = document.getElementById('prodPageBreadcrumb');
    const priceEl = document.getElementById('prodPagePrice');
    const mrpEl = document.getElementById('prodPageMrp');
    const discEl = document.getElementById('prodPageDiscount');
    const totalBtnEl = document.getElementById('prodBtnTotalPrice');
    const bottleEl = document.getElementById('prodBottleBody');
    const bottleCap = document.getElementById('prodBottleCap');
    const bottleLabel = document.getElementById('prodBottleLabel');
    const shadeSection = document.getElementById('prodShadePicker');
    const qtyEl = document.getElementById('prodPageQty');
    const waBtn = document.getElementById('prodPageWhatsAppBtn');

    if (titleEl) titleEl.textContent = productPostData.title;
    if (crumbEl) crumbEl.textContent = productPostData.title;
    if (priceEl) priceEl.textContent = '₹' + productPostData.price;
    if (mrpEl) mrpEl.textContent = '₹' + productPostData.mrp;
    if (qtyEl) qtyEl.textContent = productPostData.qty;
    if (totalBtnEl) totalBtnEl.textContent = '₹' + (productPostData.price * productPostData.qty);

    if (discEl && productPostData.mrp > productPostData.price) {
      const pct = Math.round(((productPostData.mrp - productPostData.price) / productPostData.mrp) * 100);
      discEl.textContent = 'SAVE ' + pct + '% OFF';
    }

    // Adapt visual mockups and shade section based on product category
    const cat = productPostData.cat || 'nails';
    if (cat === 'eyes') {
      if (shadeSection) shadeSection.style.display = 'none';
      if (bottleCap) { bottleCap.style.width = '24px'; bottleCap.style.height = '140px'; bottleCap.style.background = '#111'; }
      if (bottleEl) { bottleEl.style.width = '30px'; bottleEl.style.height = '60px'; bottleEl.style.background = '#222'; bottleEl.style.borderRadius = '4px'; }
      if (bottleLabel) bottleLabel.innerHTML = 'FEELORA<br><small>24H Kajal</small>';
    } else if (cat === 'removers') {
      if (shadeSection) shadeSection.style.display = 'none';
      if (bottleCap) { bottleCap.style.display = 'none'; }
      if (bottleEl) { bottleEl.style.width = '120px'; bottleEl.style.height = '90px'; bottleEl.style.background = '#85C1E9'; bottleEl.style.borderRadius = '16px'; }
      if (bottleLabel) bottleLabel.innerHTML = 'FEELORA<br><small>Aloe Wipes</small>';
    } else if (cat === 'combos') {
      if (shadeSection) shadeSection.style.display = 'none';
      if (bottleCap) { bottleCap.style.display = 'none'; }
      if (bottleEl) { bottleEl.style.width = '140px'; bottleEl.style.height = '120px'; bottleEl.style.background = 'linear-gradient(135deg, #8B1538, #C5A059)'; bottleEl.style.borderRadius = '12px'; }
      if (bottleLabel) bottleLabel.innerHTML = 'FEELORA<br><small>Glow Hamper</small>';
    } else {
      if (shadeSection) shadeSection.style.display = 'block';
      if (bottleCap) { bottleCap.style.display = 'block'; bottleCap.style.width = '38px'; bottleCap.style.height = '60px'; bottleCap.style.background = 'linear-gradient(135deg, #1A1A1A, #444)'; }
      if (bottleEl) { bottleEl.style.width = '90px'; bottleEl.style.height = '140px'; bottleEl.style.background = productPostData.color; bottleEl.style.borderRadius = '12px 12px 24px 24px'; }
      if (bottleLabel) bottleLabel.innerHTML = 'FEELORA<br><small>Nail Polish</small>';
    }

    if (waBtn) {
      const msg = encodeURIComponent('Hello Team Feelora, I want to order ' + productPostData.title + ' at Rs ' + productPostData.price);
      waBtn.href = 'https://wa.me/917848844444?text=' + msg;
    }
  }

  function selectProductPostShade(name, color, finish, btn) {
    productPostData.shade = name;
    productPostData.color = color;
    productPostData.finish = finish;

    const nameEl = document.getElementById('prodSelectedShadeName');
    const finishEl = document.getElementById('prodSelectedShadeFinish');
    const bottleEl = document.getElementById('prodBottleBody');

    if (nameEl) nameEl.textContent = name;
    if (finishEl) finishEl.textContent = finish;
    if (bottleEl) bottleEl.style.background = color;

    document.querySelectorAll('.prod-swatch-item').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');
  }

  function adjustProductPostQty(delta) {
    productPostData.qty = Math.max(1, productPostData.qty + delta);
    const qtyEl = document.getElementById('prodPageQty');
    const totalBtnEl = document.getElementById('prodBtnTotalPrice');
    if (qtyEl) qtyEl.textContent = productPostData.qty;
    if (totalBtnEl) totalBtnEl.textContent = '₹' + (productPostData.price * productPostData.qty);
  }

  function addProductPostToCart() {
    const itemTitle = productPostData.title + ' (' + productPostData.shade + ')';
    addToCart(itemTitle, productPostData.price);
    if (productPostData.qty > 1) {
      for (let i = 1; i < productPostData.qty; i++) {
        addToCart(itemTitle, productPostData.price);
      }
    }
  }

  function buyNowProductPost() {
    addProductPostToCart();
    window.location.href = '/checkout';
  }

  function checkProductPostPincode() {
    const inp = document.getElementById('prodPagePincodeInput');
    const res = document.getElementById('prodPagePincodeResult');
    if (!inp || !res) return;
    const pin = inp.value.trim();
    if (!pin || pin.length !== 6 || isNaN(pin)) {
      res.innerHTML = '<span style="color:#D32F2F;">⚠️ Please enter a valid 6-digit Indian PIN code.</span>';
      return;
    }
    res.innerHTML = '<span style="color:#2E7D32;">✓ Express Delivery Available to PIN ' + pin + '! Expected in 2-3 business days. COD Available.</span>';
  }

  function toggleProductAccordion(btn) {
    const tab = btn.closest('.accordion-tab');
    if (!tab) return;
    const content = tab.querySelector('.accordion-content');
    const arrow = tab.querySelector('.acc-arrow');
    const isOpen = tab.classList.contains('active');

    if (isOpen) {
      tab.classList.remove('active');
      if (content) content.style.display = 'none';
      if (arrow) arrow.innerHTML = '&plus;';
    } else {
      tab.classList.add('active');
      if (content) content.style.display = 'block';
      if (arrow) arrow.innerHTML = '&minus;';
    }
  }

  function setProductPostThumb(type, btn) {
    document.querySelectorAll('.prod-thumb').forEach(b => b.classList.remove('active'));
    if (btn) btn.classList.add('active');
    const bottleEl = document.getElementById('prodBottleBody');
    if (!bottleEl) return;
    if (type === 'nails') {
      bottleEl.style.borderRadius = '24px 24px 8px 8px';
    } else if (type === 'box') {
      bottleEl.style.borderRadius = '4px';
    } else {
      bottleEl.style.borderRadius = '12px 12px 24px 24px';
    }
  }

  return {
    filterStoreCatalog,
    sortStoreCatalog,
    navigateToProduct,
    selectProductPostShade,
    adjustProductPostQty,
    addProductPostToCart,
    buyNowProductPost,
    checkProductPostPincode,
    toggleProductAccordion,
    setProductPostThumb,
    openMobileNav,
    closeMobileNav,
    initPhotoSlider,
    changePhotoSlide,
    setPhotoSlide,
    switchAuthTab,
    sendOtpSimulation,
    handleLogin,
    handleRegister,
    navigateTo,
    navigateTo,
    changeHeroSlide,
    setHeroSlide,
    toggleWishlistItem,
    removeFromWishlist,
    openWishlist,
    closeWishlist,
    acceptCookies,
    declineCookies,
    openSearchModal,
    closeSearchModal,
    handleLiveSearch,
    searchQuery,
    openAccountModal,
    closeAccountModal,
    handleAuthSubmit,
    logout,
    openOrderTracking,
    downloadGstBill,
    toggleLanguage,
    applyLanguage,
    openProductModal,
    openProductModalFromCard,
    closeProductModal,
    selectModalShade,
    adjustModalQty,
    addModalProductToCart,
    buyNowModal,
    orderOnWhatsAppModal,
    checkModalPincode,
    toggleAccordion,
    setModalThumbView,
    updateMarginPreview,
    handleDistributorSubmit,
    toggleByobItem,
    addByobToCart,
    addToCart,
    removeFromCart,
    openCartDrawer,
    closeCartDrawer,
    copyCoupon,
    checkPincode,
    filterProducts,
    openShadePicker,
    switchFinish,
    downloadPriceList,
    proceedToCheckout,
    toggleMobileNav,
    searchProducts
  };
})();